var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubscriptionDirect28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#subscription_direct_28)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.125 20.033a6.16 6.16 0 1 0-6.074-5.13c.177 1.048.289 2.141-.074 3.14l-.147.404c-.314.863-.47 1.294-.374 1.575a.84.84 0 0 0 .52.521c.282.097.713-.06 1.576-.374l.404-.147c.999-.363 2.092-.25 3.14-.074.335.056.679.085 1.03.085Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "subscription_direct_28",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA61F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6950E6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionDirect28);
export default __webpack_public_path__ + "static/media/subscription_direct_28.67998cb5.svg";
export { ForwardRef as ReactComponent };